import { render, staticRenderFns } from "./ModificaDatiStruttura.vue?vue&type=template&id=358cdf08&scoped=true&"
import script from "./ModificaDatiStruttura.vue?vue&type=script&lang=js&"
export * from "./ModificaDatiStruttura.vue?vue&type=script&lang=js&"
import style0 from "./ModificaDatiStruttura.vue?vue&type=style&index=0&id=358cdf08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358cdf08",
  null
  
)

export default component.exports